//Angular
import { Component, OnInit, ViewContainerRef, Input, ComponentFactory, ReflectiveInjector, Compiler, Inject } from "@angular/core";

//Services
import { LanguageService } from "./../../../../../../services/cms/language.service";
import { ProductService } from "./../../../../../../services/inventory/product.service";
import { ComponentHelperService } from "./../../../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../../../services/settings/template.service";
import { ShoppingCartService } from "./../../../../../../services/inventory/shopping-cart.service";

import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: "dy-quoting-order-totals-widget",
    template: ""
})
export class QuotingOrderTotalsComponent implements OnInit 
{
    constructor
    (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private templateService: TemplateService,
        @Inject('isBrowser') private isBrowser: boolean
    ) {}

    subManager = new Subscription();

    ngOnInit() 
    {
        if (!this.isBrowser)
            return;
            
        let templateHtml: string;

        let orderTotalSub = this.templateService.getComponentTemplate("quotingOrderTotalsWidgetTemplate").subscribe(result => 
        {
            templateHtml = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(templateHtml);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        });
        
        this.subManager.add(orderTotalSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(template: string) {

        @Component({
            template: template
        })

        class ChildComponent implements OnInit 
        {
            constructor
            (
                private productService: ProductService, 
                private languageService: LanguageService, 
                private cartService: ShoppingCartService,
                private _elementChildRef: ViewContainerRef
            ) {}

            ngOnInit() {}

        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/widget/quoting-result/wizard/widget/quoting-order-totals.component.ts